import { useMemo } from 'react';

import { useChats } from './useChats';

// Client-side filter over `useChats()` — no second network request, shares the same query cache.
export const useLeadChats = (loanRequestId: string) => {
    const query = useChats();

    const chats = useMemo(
        () => (query.data ?? []).filter((chat) => chat.loanRequestIds.includes(loanRequestId)),
        [query.data, loanRequestId],
    );

    return { ...query, data: chats };
};
